import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Image,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  SimpleGrid,
  Skeleton,
  Text,
  VStack,
  Badge,
  Icon,
  Heading,
} from "@chakra-ui/react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import totalleads from "../../icons/totalleads.svg";
import openleads from "../../icons/openleads.svg";
import finalleads from "../../icons/finalleads.svg";
import hotleads from "../../icons/hotleads.svg";
import unsubscribe from "../../icons/unsubscribe.svg";
import wronglead from "../../icons/wronglead.svg";
import enrolled from "../../icons/enrolled.svg";

import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../../redux/actions/common.action";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { FiUsers } from "react-icons/fi";
import format from "date-fns/format";
import { DateRange } from "react-date-range";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Cookies from "js-cookie";
import { BASE_URL } from "../../config/RequestMethod";
import axios from "axios";

import iconBadge from "../../icons/icons8-badge.png";
import iconCancelOne from "../../icons/icons8-cancel-1.png";
import iconCancel from "../../icons/icons8-cancel.png";
import iconCheck from "../../icons/icons8-check.png";
import iconChili from "../../icons/icons8-chili-pepper.png";
import iconClosed from "../../icons/icons8-closed.png";
import iconDoor from "../../icons/icons8-door.png";
import iconFinish from "../../icons/icons8-finish.png";
import iconHot from "../../icons/icons8-hot.png";
import iconLast from "../../icons/icons8-last.png";
import iconLock from "../../icons/icons8-lock.png";
import iconMedal from "../../icons/icons8-medal.png";
import iconOpen from "../../icons/icons8-open.png";
import iconPlay from "../../icons/icons8-play.png";
import iconPurchasedOne from "../../icons/icons8-purchase-1.png";
import iconPurchased from "../../icons/icons8-purchase.png";
import iconStartOne from "../../icons/icons8-start-1.png";
import iconStart from "../../icons/icons8-start.png";
import icontrophy from "../../icons/icons8-trophy.png";
import iconUnlock from "../../icons/icons8-unlock.png";
import TodoList from "./Todo/TodoList";
import { useNavigate } from "react-router-dom";
import {
  BarChart3,
  Package,
  Users,
  Activity,
  TrendingUp,
  Sparkles,
  Calendar,
  Filter,
} from "lucide-react";

// Define the shape of the analytics data
interface Analytics {
  leadscount: [
    {
      name: string;
      count: number;
      price: number;
      icon?: string;
      color?: string;
    }
  ];
  sourceanalytics: {
    _id: string;
    sourceName: string;
    count: number;
  }[];
  courseanalytics: {
    courseName: string;
    courseId: string;
    totalLeads: number;
    [key: string]: any;
  }[];
  statuses: {
    serialNumber: number;
    createdAt: string;
    StatusName: string;
    _id: number;
  }[];
  signinuser: {
    UserType: number;
    Name: string;
    UserProfile: string;
  };
  loading: boolean;
}

const AdminDashboard = () => {
  const navigate = useNavigate();

  const {
    leadscount,
    sourceanalytics,
    courseanalytics,
    statuses,
    signinuser,
    loading,
  } = useSelector((state: { common: Analytics }) => state.common);

  const dispatch: any = useDispatch();

  useEffect(() => {
    if (!leadscount?.length) dispatch(getData("dashboard/leads-count"));
    if (!sourceanalytics?.length) dispatch(getData("dashboard/source"));
  }, [dispatch]);

  const refTwo = useRef<HTMLDivElement>(null);

  const [selectedStatus, setSelectedStatus] = useState("Total Leads");
  const [callAnalytics, setCallAnalytics] = useState([]);
  const [openenq, setOpenenq] = useState(false);

  const today = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(today.getDate() - 29);
  const [enquiryDate, setEnqDate] = useState([
    {
      startDate: thirtyDaysAgo,
      endDate: today,
      key: "selection",
    },
  ]);

  const [{ startDate: enquiryStartDate, endDate: enquiryEndDate }] =
    enquiryDate;

  useEffect(() => {
    const token = Cookies.get("token");

    if (signinuser?.UserType === 2 || signinuser?.UserType === 3) {
      const newURL = `${BASE_URL}dashboard/calls?startDate=${enquiryStartDate}&endDate=${enquiryEndDate}`;

      const getCalls = async () => {
        try {
          const res = await axios.get(newURL, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          setCallAnalytics(res?.data?.Data);
        } catch (error) {
          console.error("Error fetching call analytics:", error);
          setCallAnalytics([]);
        }
      };

      getCalls();
    }
  }, [enquiryDate, signinuser?.UserType]);

  useEffect(() => {
    const handleEvents = (event: Event) => {
      if (event instanceof KeyboardEvent && event.key === "Escape") {
        setOpenenq(false);
      } else if (event instanceof MouseEvent) {
        if (refTwo.current && !refTwo.current.contains(event.target as Node)) {
          setOpenenq(false);
        }
      }
    };

    document.addEventListener("keydown", handleEvents);
    document.addEventListener("mousedown", handleEvents);

    return () => {
      document.removeEventListener("keydown", handleEvents);
      document.removeEventListener("mousedown", handleEvents);
    };
  }, []);

  useEffect(() => {
    if (!statuses?.length) dispatch(getData("status"));
    if (!courseanalytics?.length) dispatch(getData("dashboard/analytics"));
  }, [dispatch, selectedStatus]);

  useEffect(() => {
    if (statuses?.length > 0 && !selectedStatus) {
      setSelectedStatus(statuses[0]?.StatusName);
    }
  }, [statuses]);

  const charToIconMap: { [key: string]: string } = {
    a: totalleads,
    b: openleads,
    c: unsubscribe,
    d: hotleads,
    e: unsubscribe,
    f: finalleads,
    g: enrolled,
    h: totalleads,
    i: openleads,
    j: finalleads,
    k: hotleads,
    l: unsubscribe,
    m: wronglead,
    n: enrolled,
    o: openleads,
    p: openleads,
    q: finalleads,
    r: hotleads,
    s: unsubscribe,
    t: totalleads,
    u: enrolled,
    v: totalleads,
    w: openleads,
    x: finalleads,
    y: hotleads,
    z: unsubscribe,
  };

  const iconsArray = [
    { name: "Badge", value: iconBadge, local: "iconBadge" },
    { name: "Cancel", value: iconCancel, local: "iconCancel" },
    { name: "CancelOne", value: iconCancelOne, local: "iconCancelOne" },
    { name: "Check", value: iconCheck, local: "iconCheck" },
    { name: "Chili", value: iconChili, local: "iconChili" },
    { name: "Closed", value: iconClosed, local: "iconClosed" },
    { name: "Door", value: iconDoor, local: "iconDoor" },
    { name: "Finish", value: iconFinish, local: "iconFinish" },
    { name: "Hot", value: iconHot, local: "iconHot" },
    { name: "Last", value: iconLast, local: "iconLast" },
    { name: "Lock", value: iconLock, local: "iconLock" },
    { name: "Medal", value: iconMedal, local: "iconMedal" },
    { name: "Open", value: iconOpen, local: "iconOpen" },
    { name: "Play", value: iconPlay, local: "iconPlay" },
    { name: "Purchased", value: iconPurchased, local: "iconPurchased" },
    {
      name: "PurchasedOne",
      value: iconPurchasedOne,
      local: "iconPurchasedOne",
    },
    { name: "Start", value: iconStart, local: "iconStart" },
    { name: "StartOne", value: iconStartOne, local: "iconStartOne" },
    { name: "Unlock", value: iconUnlock, local: "iconUnlock" },
    { name: "trophy", value: icontrophy, local: "icontrophy" },
  ];

  // Donut Chart for Top Products
  const donutSeries = courseanalytics?.map((course: any) =>
    selectedStatus === "Total Leads"
      ? course?.totalLeads || 0
      : course?.[selectedStatus]?.leads || 0
  );

  const donutOptions: ApexOptions = {
    chart: {
      type: "donut",
      fontFamily: "Inter, sans-serif",
    },
    labels: courseanalytics?.map((c: any) => c?.courseName || "Unknown"),
    colors: [
      "#3B82F6",
      "#8B5CF6",
      "#EC4899",
      "#10B981",
      "#F59E0B",
      "#06B6D4",
      "#EF4444",
      "#6366F1",
    ],
    legend: {
      position: "bottom",
      fontSize: "12px",
      fontWeight: 500,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "14px",
              fontWeight: 600,
            },
            value: {
              show: true,
              fontSize: "24px",
              fontWeight: 700,
              formatter: (val) => val.toString(),
            },
            total: {
              show: true,
              label: selectedStatus,
              fontSize: "14px",
              fontWeight: 600,
              formatter: () => {
                const total = donutSeries.reduce((a, b) => a + b, 0);
                return total.toString();
              },
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "11px",
        fontWeight: "600",
      },
    },
    tooltip: {
      theme: "light",
      y: {
        formatter: (val) => `${val} leads`,
      },
    },
  };

  // Area Chart for Call Analytics
  const areaSeries = [
    {
      name: "Leads",
      data: callAnalytics?.map((c: any) => c?.totalLeads || 0),
    },
  ];

  const areaOptions: ApexOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      fontFamily: "Inter, sans-serif",
      sparkline: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.6,
        opacityTo: 0.1,
        stops: [0, 90, 100],
      },
    },
    xaxis: {
      categories: callAnalytics?.map((c: any) => c?.userName || "Unknown"),
      labels: {
        style: {
          fontSize: "11px",
          fontWeight: "500",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "11px",
          fontWeight: "600",
        },
      },
    },
    colors: ["#10B981"],
    grid: {
      borderColor: "#E2E8F0",
      strokeDashArray: 3,
    },
    tooltip: {
      theme: "light",
      x: {
        show: true,
      },
      y: {
        formatter: (val) => `${val} leads`,
      },
    },
  };

  // Radial Bar Chart for Source Analytics
  const radialSeries = sourceanalytics?.map((s: any) => {
    const total = sourceanalytics.reduce(
      (sum: number, item: any) => sum + item.count,
      0
    );
    return Math.round((s.count / total) * 100);
  });

  const radialOptions: ApexOptions = {
    chart: {
      type: "radialBar",
      fontFamily: "Inter, sans-serif",
    },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          margin: 5,
          size: "30%",
          background: "transparent",
        },
        dataLabels: {
          name: {
            show: true,
            fontSize: "12px",
            fontWeight: 600,
          },
          value: {
            show: true,
            fontSize: "16px",
            fontWeight: 700,
            formatter: (val) => `${val}%`,
          },
        },
      },
    },
    colors: ["#EC4899", "#8B5CF6", "#10B981", "#F59E0B", "#06B6D4", "#3B82F6"],
    labels: sourceanalytics?.map((s: any) => s?.sourceName || "Unknown"),
    legend: {
      show: true,
      floating: true,
      fontSize: "11px",
      position: "left",
      offsetX: 10,
      offsetY: 10,
      labels: {
        useSeriesColors: true,
      },
      formatter: function (seriesName, opts) {
        const actualCount = sourceanalytics[opts.seriesIndex]?.count || 0;
        return `${seriesName}: ${actualCount}`;
      },
    },
  };

  const getUserGreeting = () => {
    const hour = new Date().getHours();
    let greeting = "Good Morning";
    if (hour >= 12 && hour < 17) greeting = "Good Afternoon";
    else if (hour >= 17) greeting = "Good Evening";

    return `${greeting}, ${signinuser?.Name || "User"}!`;
  };

  // Pie Chart for Products
  const pieseries = courseanalytics?.map((course: any) =>
    selectedStatus === "Total Leads"
      ? course?.totalLeads || 0
      : course?.[selectedStatus]?.leads || 0
  );
  const hasPieData =
    Array.isArray(pieseries) && pieseries.some((val: number) => val > 0);

  const pieoptions: ApexOptions = {
    chart: {
      type: "pie",
      fontFamily: "Inter, sans-serif",
    },
    labels: courseanalytics?.map((c: any) => c?.courseName || "Unknown"),
    colors: [
      "#8B5CF6",
      "#EC4899",
      "#F59E0B",
      "#10B981",
      "#3B82F6",
      "#EF4444",
      "#06B6D4",
      "#6366F1",
    ],
    legend: {
      position: "bottom",
      fontSize: "11px",
      fontWeight: 500,
      markers: {
        width: 8,
        height: 8,
        radius: 2,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "11px",
        fontWeight: "600",
      },
      dropShadow: {
        enabled: false,
      },
    },
    stroke: {
      width: 2,
      colors: ["#fff"],
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} leads`,
      },
    },
    plotOptions: {
      pie: {
        expandOnClick: true,
        dataLabels: {
          offset: -5,
        },
      },
    },
  };

  // Bar Chart for Calls
  const barseries = [
    {
      name: "Leads",
      data: callAnalytics?.map((c: any) => c?.totalLeads || 0),
    },
  ];
  const hasBarData =
    Array.isArray(barseries?.[0]?.data) &&
    (barseries[0].data as number[]).some((val) => val > 0);

  const baroptions: ApexOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      fontFamily: "Inter, sans-serif",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 8,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: "11px",
        fontWeight: "600",
        colors: ["#1A202C"],
      },
    },
    colors: ["#10B981"],
    xaxis: {
      categories: callAnalytics?.map((c: any) => c?.userName || "Unknown"),
      labels: {
        style: {
          fontSize: "11px",
          fontWeight: 500,
        },
        rotate: -45,
        rotateAlways: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "11px",
          fontWeight: 600,
        },
      },
    },
    grid: {
      borderColor: "#E2E8F0",
      strokeDashArray: 3,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} leads`,
      },
    },
  };

  // Line Chart for Sources
  const lineseries = [
    {
      name: "Leads",
      data: sourceanalytics?.map((s: any) => s?.count || 0),
    },
  ];
  const hasLineData =
    Array.isArray(lineseries?.[0]?.data) &&
    (lineseries[0].data as number[]).some((val) => val > 0);

  const lineoptions: ApexOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
      fontFamily: "Inter, sans-serif",
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    markers: {
      size: 5,
      colors: ["#F97316"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    colors: ["#F97316"],
    xaxis: {
      categories: sourceanalytics?.map((s: any) => s?.sourceName || "Unknown"),
      labels: {
        style: {
          fontSize: "11px",
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "11px",
          fontWeight: 600,
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "10px",
        fontWeight: "600",
      },
      background: {
        enabled: true,
        foreColor: "#fff",
        borderRadius: 4,
        padding: 4,
        opacity: 0.9,
        borderWidth: 1,
        borderColor: "#F97316",
      },
    },
    grid: {
      borderColor: "#E2E8F0",
      strokeDashArray: 3,
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} leads`,
      },
    },
  };

  return (
    <Box bg="gray.50" minH="100vh">
      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translate(0, 0) rotate(0deg); }
            33% { transform: translate(30px, -30px) rotate(5deg); }
            66% { transform: translate(-20px, 20px) rotate(-5deg); }
          }
          
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes scaleIn {
            from {
              opacity: 0;
              transform: scale(0.9);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
          
          @keyframes shimmer {
            0% { background-position: -200% center; }
            100% { background-position: 200% center; }
          }
            /* Date Range Picker Styles */
    .calendarElement {
      background: white;
      border: none;
      border-radius: 8px;
      padding: 12px;
      font-family: 'Inter', sans-serif;
    }

    .calendarElement .rdrMonth {
      width: 100%;
    }

    .calendarElement .rdrDayNumber {
      color: #1f2937;
      font-weight: 500;
      font-size: 13px;
    }

    .calendarElement .rdrDay {
      height: 32px;
    }

    .calendarElement .rdrDayStartPreview,
    .calendarElement .rdrDayInPreview,
    .calendarElement .rdrDayEndPreview {
      background: #10B98120;
      border: none;
    }

    .calendarElement .rdrDayStartPreview:hover,
    .calendarElement .rdrDayInPreview:hover,
    .calendarElement .rdrDayEndPreview:hover {
      background: #10B98133;
    }

    .calendarElement .rdrDayActive {
      background: #10B981;
      color: white;
      font-weight: 600;
    }

    .calendarElement .rdrDayActive:hover {
      background: #059669;
    }

    .calendarElement .rdrMonthName {
      color: #1f2937;
      font-weight: 700;
      font-size: 14px;
    }

    .calendarElement .rdrWeekDay {
      color: #6b7280;
      font-weight: 600;
      font-size: 12px;
    }

    .calendarElement .rdrDateDisplayItem {
      background: #f3f4f6;
      border: 1px solid #e5e7eb;
      border-radius: 6px;
      color: #1f2937;
      font-weight: 500;
    }

    .calendarElement .rdrDateDisplayItem input {
      color: #1f2937;
      font-weight: 600;
      font-size: 13px;
    }

    .calendarElement .rdrDateDisplayItemActive {
      border: 1px solid #10B981;
      background: #10B98110;
    }

    .calendarElement .rdrNext,
    .calendarElement .rdrPrev {
      padding: 6px 8px;
    }

    .calendarElement .rdrNext button,
    .calendarElement .rdrPrev button {
      background: #f3f4f6;
      border: 1px solid #e5e7eb;
      border-radius: 4px;
      color: #1f2937;
      font-weight: 600;
      transition: all 0.2s;
    }

    .calendarElement .rdrNext button:hover,
    .calendarElement .rdrPrev button:hover {
      background: #10B981;
      color: white;
      border-color: #10B981;
    }

    .calendarElement .rdrDefinedRangesWrapper {
      border-right: 1px solid #e5e7eb;
      padding-right: 12px;
    }

    .calendarElement .rdrStaticRanges .rdrStaticRange {
      background: white;
      border: 1px solid #e5e7eb;
      border-radius: 6px;
      color: #1f2937;
      font-weight: 500;
      font-size: 12px;
      padding: 6px 8px;
      margin-bottom: 4px;
    }

    .calendarElement .rdrStaticRanges .rdrStaticRange:hover {
      background: #f3f4f6;
      border-color: #10B981;
    }

    .calendarElement .rdrStaticRanges .rdrStaticRange.active {
      background: #10B981;
      color: white;
      border-color: #10B981;
    }

    /* Ensure calendar is above other elements */
    .calendarElement {
      position: relative;
      z-index: 1000;
    }
        `}
      </style>

      {/* Modern Gradient Header */}
      <Box
        position="relative"
        bgGradient="linear(to-br, blue.600, purple.600, pink.500)"
        overflow="hidden"
        mb={2}
      >
        {/* Animated Background Elements */}
        <Box
          position="absolute"
          top="-50%"
          right="-10%"
          w="500px"
          h="500px"
          borderRadius="full"
          bg="whiteAlpha.100"
          filter="blur(80px)"
          animation="float 20s infinite ease-in-out"
        />
        <Box
          position="absolute"
          bottom="-30%"
          left="-5%"
          w="400px"
          h="400px"
          borderRadius="full"
          bg="whiteAlpha.100"
          filter="blur(60px)"
          animation="float 25s infinite ease-in-out reverse"
        />

        <Container maxW="9xl" position="relative" zIndex={1}>
          <VStack
            spacing={2}
            align="start"
            py={{ base: 6, md: 8 }}
            px={{ base: 4, md: 8 }}
          >
            {/* Badge */}
            <HStack
              bg="whiteAlpha.200"
              backdropFilter="blur(10px)"
              px={4}
              py={2}
              borderRadius="full"
              border="1px"
              borderColor="whiteAlpha.300"
              animation="slideUp 0.6s ease-out"
            >
              <Icon as={Sparkles} boxSize={4} color="yellow.300" />
              <Text fontSize="sm" color="white" fontWeight="medium">
                {signinuser?.UserType === 2
                  ? "Admin Dashboard"
                  : "User Dashboard"}
              </Text>
              <Badge
                colorScheme={signinuser?.UserType === 2 ? "yellow" : "green"}
                fontSize="xs"
                borderRadius="full"
              >
                {signinuser?.UserProfile || "Admin"}
              </Badge>
            </HStack>

            {/* Main Heading */}
            <VStack align="start" spacing={2}>
              <Heading
                as="h2"
                fontSize={{ base: "xl", md: "3xl", lg: "4xl" }}
                fontWeight="black"
                color="white"
                lineHeight="1.2"
                textShadow="0 4px 20px rgba(0,0,0,0.2)"
                animation="slideUp 0.8s ease-out"
              >
                {getUserGreeting()}
              </Heading>

              <HStack spacing={3} animation="slideUp 1s ease-out">
                <Icon as={Activity} boxSize={5} color="whiteAlpha.900" />
                <Text
                  fontSize={{ base: "sm", md: "md" }}
                  color="whiteAlpha.900"
                  fontWeight="medium"
                >
                  Track your performance and manage your leads effectively
                </Text>
              </HStack>
            </VStack>
          </VStack>
        </Container>

        {/* Bottom Wave */}
        <Box
          position="absolute"
          bottom="-25px"
          left="0"
          right="0"
          height="60px"
        >
          <svg
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            style={{ width: "100%", height: "100%" }}
          >
            <path
              d="M0,0 C150,100 350,0 600,50 C850,100 1050,0 1200,50 L1200,120 L0,120 Z"
              fill="#F7FAFC"
            />
          </svg>
        </Box>
      </Box>

      <Container maxW="9xl" px={{ base: 4, md: 4 }}>
        {/* Stats Cards */}
        <SimpleGrid columns={{ base: 2, md: 3, lg: 5, xl: 5 }} gap={4} mb={6}>
          {loading || leadscount?.length < 1
            ? Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} h="110px" borderRadius="2xl" />
              ))
            : leadscount?.map((el: any, i) => {
                const iconName = el?.name?.toLowerCase()?.charAt(0);
                const iconPath = charToIconMap[iconName] || totalleads;
                const bgColor = el?.color || "#4A90E2"; // fallback color

                return (
                  <Box
                    key={i}
                    position="relative"
                    h="110px"
                    bgGradient={`linear(to-br, ${bgColor}80, ${bgColor}25)`}
                    borderRadius="2xl"
                    border="1px solid"
                    borderColor={`${bgColor}20`}
                    overflow="hidden"
                    transition="all 0.3s ease"
                    _hover={{
                      transform: "translateY(-4px) scale(1.02)",
                      boxShadow: `0 8px 18px -6px ${bgColor}40`,
                      bgGradient: `linear(to-br, ${bgColor}60, ${bgColor}35)`,
                    }}
                    cursor="pointer"
                    backdropFilter="blur(6px)"
                  >
                    {/* Glow Accent Circle */}
                    <Box
                      position="absolute"
                      top="-40px"
                      right="-40px"
                      w="100px"
                      h="100px"
                      bg={bgColor}
                      borderRadius="full"
                      filter="blur(45px)"
                      opacity="0.4"
                    />

                    {/* Colored Top Line */}
                    <Box
                      position="absolute"
                      top={0}
                      left={0}
                      right={0}
                      h="2px"
                      bg={bgColor}
                      opacity="0.8"
                    />

                    {/* Content */}
                    <Flex
                      align="center"
                      gap={3}
                      p={4}
                      position="relative"
                      h="full"
                      zIndex={1}
                    >
                      {/* Icon */}
                      <Box
                        p={2}
                        bg={`${bgColor}22`}
                        borderRadius="lg"
                        transition="all 0.3s"
                        _groupHover={{ transform: "scale(1.05)" }}
                        flexShrink={0}
                      >
                        <Image
                          boxSize="34px"
                          src={
                            el?.icon
                              ? iconsArray?.find(
                                  (i: any) => i?.local === el?.icon
                                )?.value
                              : iconPath
                          }
                          alt="icon"
                        />
                      </Box>

                      {/* Text */}
                      <VStack align="start" spacing={0} flex={1} minW={0}>
                        <Text
                          fontSize="2xl"
                          fontWeight="900"
                          color="gray.900"
                          lineHeight="1"
                        >
                          {el?.count || 0}
                        </Text>
                        <Flex
                          gap={1}
                          w="full"
                          flexDirection={{ base: "column", md: "row" }}
                          justify="space-between"
                        >
                          <Text
                            fontSize="12px"
                            fontWeight="600"
                            color="gray.500"
                            textTransform="uppercase"
                            letterSpacing="0.3px"
                            noOfLines={1}
                          >
                            {el?.name}
                          </Text>
                          <Text
                            fontSize="16px"
                            fontWeight="700"
                            color="gray.800"
                            flexShrink={0}
                          >
                            ₹{(el?.price || 0).toLocaleString("en-IN")}
                          </Text>
                        </Flex>
                      </VStack>
                    </Flex>
                  </Box>
                );
              })}
        </SimpleGrid>

        {/* Charts Section */}
        <SimpleGrid columns={{ base: 1, lg: 3 }} gap={6} mb={6}>
          {/* Pie Chart - Top Products */}
          <Box
            bg="white"
            borderRadius="2xl"
            boxShadow="sm"
            border="1px"
            borderColor="gray.200"
            overflow="hidden"
            transition="all 0.3s"
            _hover={{
              boxShadow: "xl",
              transform: "translateY(-4px)",
            }}
            animation="slideUp 0.5s ease-out"
            position="relative"
          >
            {/* Background gradient pattern */}
            <Box
              position="absolute"
              top="0"
              left="0"
              right="0"
              bottom="0"
              bgGradient="radial(circle at 20% 80%, purple.50 0%, transparent 50%)"
              opacity="0.5"
            />

            <Box position="relative" zIndex="1">
              <Flex
                bgGradient="linear(to-r, purple.50, pink.50)"
                px={6}
                py={4}
                align="center"
                justify="space-between"
                borderBottom="1px"
                borderColor="gray.200"
              >
                <HStack spacing={3}>
                  <Box
                    p={2}
                    bgGradient="linear(to-br, purple.500, pink.500)"
                    borderRadius="lg"
                    boxShadow="md"
                    transition="all 0.3s"
                    _groupHover={{
                      transform: "rotate(5deg) scale(1.1)",
                    }}
                  >
                    <Icon as={Package} boxSize={5} color="white" />
                  </Box>
                  <VStack align="start" spacing={0}>
                    <Text fontSize="sm" fontWeight="bold" color="gray.800">
                      Top Products
                    </Text>
                    <Text fontSize="xs" color="gray.600">
                      Distribution Analysis
                    </Text>
                  </VStack>
                </HStack>

                <Menu>
                  <MenuButton
                    as={Button}
                    rightIcon={<ChevronDownIcon />}
                    size="xs"
                    colorScheme="purple"
                    variant="ghost"
                    fontSize="xs"
                    leftIcon={<Icon as={Filter} boxSize={3} />}
                  >
                    {selectedStatus}
                  </MenuButton>
                  <MenuList borderRadius="xl" boxShadow="lg" zIndex={10}>
                    <MenuItem onClick={() => setSelectedStatus("Total Leads")}>
                      <HStack spacing={2}>
                        <FiUsers size={14} />
                        <Text fontSize="xs">Total Leads</Text>
                      </HStack>
                    </MenuItem>

                    {statuses?.map((status) => {
                      const name = status?.StatusName || "";
                      const iconKey = name.toLowerCase().charAt(0);
                      const icon = charToIconMap[iconKey] || totalleads;

                      return (
                        <MenuItem
                          key={name}
                          onClick={() => setSelectedStatus(name)}
                          _hover={{ bg: "purple.50" }}
                        >
                          <HStack spacing={2}>
                            <Image src={icon} alt="icon" boxSize="14px" />
                            <Text fontSize="xs">{name}</Text>
                          </HStack>
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </Menu>
              </Flex>

              <Box p={6}>
                {hasPieData ? (
                  <Chart
                    options={pieoptions}
                    series={pieseries}
                    type="pie"
                    height={320}
                  />
                ) : (
                  <VStack py={16} spacing={3}>
                    <Package size={48} color="#CBD5E0" />
                    <Text fontSize="sm" color="gray.500" fontWeight="medium">
                      No data for this chart
                    </Text>
                  </VStack>
                )}
              </Box>
            </Box>
          </Box>

          {/* Bar Chart - Call Analytics */}
          <Box
            bg="white"
            borderRadius="2xl"
            boxShadow="sm"
            border="1px"
            borderColor="gray.200"
            overflow="visible"
            transition="all 0.3s"
            _hover={{
              boxShadow: "xl",
              transform: "translateY(-4px)",
            }}
            animation="slideUp 0.6s ease-out"
            position="relative"
          >
            {/* Background gradient pattern */}
            <Box
              position="absolute"
              top="0"
              left="0"
              right="0"
              bottom="0"
              bgGradient="radial(circle at 80% 20%, green.50 0%, transparent 50%)"
              opacity="0.5"
              borderRadius="2xl"
            />

            <Box position="relative" zIndex="1">
              <VStack align="stretch" spacing={0}>
                <Flex
                  bgGradient="linear(to-r, green.50, teal.50)"
                  px={6}
                  py={4}
                  align="center"
                  justify="space-between"
                  borderBottom="1px"
                  borderColor="gray.200"
                >
                  <HStack spacing={3}>
                    <Box
                      p={2}
                      bgGradient="linear(to-br, green.500, teal.500)"
                      borderRadius="lg"
                      boxShadow="md"
                      transition="all 0.3s"
                      _groupHover={{
                        transform: "rotate(-5deg) scale(1.1)",
                      }}
                    >
                      <Icon as={Users} boxSize={5} color="white" />
                    </Box>
                    <VStack align="start" spacing={0}>
                      <Text fontSize="sm" fontWeight="bold" color="gray.800">
                        Call Analytics
                      </Text>
                      <Text fontSize="xs" color="gray.600">
                        Team Performance
                      </Text>
                    </VStack>
                  </HStack>

                  <Badge
                    colorScheme="green"
                    fontSize="xs"
                    borderRadius="full"
                    px={3}
                    py={1}
                  >
                    Active
                  </Badge>
                </Flex>

                {/* Date Picker Section - Fixed */}
                <Box px={6} pt={4} pb={3} position="relative">
                  <HStack
                    bg="white"
                    px={3}
                    py={2.5}
                    borderRadius="lg"
                    spacing={2}
                    border="2px solid"
                    borderColor="gray.300"
                    transition="all 0.2s"
                    _hover={{
                      borderColor: "green.400",
                      boxShadow: "0 0 0 1px #10B981",
                    }}
                    _focus={{
                      borderColor: "green.500",
                      boxShadow: "0 0 0 2px #10B98133",
                    }}
                  >
                    <Icon as={Calendar} boxSize={4} color="gray.700" />

                    <Input
                      size="sm"
                      fontSize="xs"
                      cursor="pointer"
                      fontWeight="600"
                      placeholder="Click to select date range"
                      value={
                        enquiryDate[0].startDate && enquiryDate[0].endDate
                          ? `${format(
                              enquiryDate[0].startDate,
                              "dd MMM"
                            )} - ${format(
                              enquiryDate[0].endDate,
                              "dd MMM yyyy"
                            )}`
                          : "Select date range"
                      }
                      readOnly
                      onClick={() => setOpenenq((prev) => !prev)}
                      bg="white"
                      color="gray.900"
                      border="none"
                      _placeholder={{ color: "gray.500", fontWeight: "500" }}
                      _focus={{
                        boxShadow: "none",
                        outline: "none",
                      }}
                      _active={{
                        boxShadow: "none",
                        outline: "none",
                      }}
                      style={{
                        outline: "none",
                        boxShadow: "none",
                      }}
                    />
                  </HStack>

                  {/* Date Range Picker Dropdown */}
                  {openenq && (
                    <Box
                      ref={refTwo}
                      position="absolute"
                      top="100%"
                      left="0"
                      mt={2}
                      bg="white"
                      borderRadius="xl"
                      boxShadow="2xl"
                      border="1px"
                      borderColor="gray.300"
                      zIndex={1000}
                      maxW="100%"
                      overflow="visible"
                      style={{
                        overflow: "visible",
                      }}
                    >
                      <Box p={2} bg="white" borderRadius="xl">
                        <DateRange
                          onChange={(item: any) => setEnqDate([item.selection])}
                          editableDateInputs
                          moveRangeOnFirstSelection={false}
                          ranges={enquiryDate.map((r) => ({
                            ...r,
                            startDate: r.startDate || undefined,
                            endDate: r.endDate || undefined,
                          }))}
                          direction="horizontal"
                          className="calendarElement"
                          maxDate={new Date()}
                        />
                      </Box>
                    </Box>
                  )}
                </Box>

                {/* Chart */}
                <Box p={6} pt={2}>
                  {hasBarData ? (
                    <Chart
                      options={baroptions}
                      series={barseries}
                      type="bar"
                      height={280}
                    />
                  ) : (
                    <VStack py={16} spacing={3}>
                      <Users size={48} color="#CBD5E0" />
                      <Text fontSize="sm" color="gray.500" fontWeight="medium">
                        No data for this chart
                      </Text>
                    </VStack>
                  )}
                </Box>
              </VStack>
            </Box>
          </Box>

          {/* Line Chart - Source Analytics */}
          <Box
            bg="white"
            borderRadius="2xl"
            boxShadow="sm"
            border="1px"
            borderColor="gray.200"
            overflow="hidden"
            transition="all 0.3s"
            _hover={{
              boxShadow: "xl",
              transform: "translateY(-4px)",
            }}
            animation="slideUp 0.7s ease-out"
            position="relative"
          >
            {/* Background gradient pattern */}
            <Box
              position="absolute"
              top="0"
              left="0"
              right="0"
              bottom="0"
              bgGradient="radial(circle at 50% 50%, orange.50 0%, transparent 50%)"
              opacity="0.5"
            />

            <Box position="relative" zIndex="1">
              <Flex
                bgGradient="linear(to-r, orange.50, red.50)"
                px={6}
                py={4}
                align="center"
                justify="space-between"
                borderBottom="1px"
                borderColor="gray.200"
              >
                <HStack spacing={3}>
                  <Box
                    p={2}
                    bgGradient="linear(to-br, orange.500, red.500)"
                    borderRadius="lg"
                    boxShadow="md"
                    transition="all 0.3s"
                    _groupHover={{
                      transform: "rotate(5deg) scale(1.1)",
                    }}
                  >
                    <Icon as={BarChart3} boxSize={5} color="white" />
                  </Box>
                  <VStack align="start" spacing={0}>
                    <Text fontSize="sm" fontWeight="bold" color="gray.800">
                      Source Analytics
                    </Text>
                    <Text fontSize="xs" color="gray.600">
                      Trend Analysis
                    </Text>
                  </VStack>
                </HStack>
                <Badge
                  colorScheme="orange"
                  fontSize="xs"
                  borderRadius="full"
                  px={3}
                  py={1}
                >
                  {sourceanalytics?.length || 0} Sources
                </Badge>
              </Flex>

              <Box p={6}>
                {hasLineData ? (
                  <Chart
                    options={lineoptions}
                    series={lineseries}
                    type="line"
                    height={320}
                  />
                ) : (
                  <VStack py={16} spacing={3}>
                    <BarChart3 size={48} color="#CBD5E0" />
                    <Text fontSize="sm" color="gray.500" fontWeight="medium">
                      No data for this chart
                    </Text>
                  </VStack>
                )}
              </Box>
            </Box>
          </Box>
        </SimpleGrid>

        {/* Todo List */}
        <Box pb={8}>
          <TodoList />
        </Box>
      </Container>
    </Box>
  );
};

export default AdminDashboard;
